module.exports = __webpack_public_path__ + "static/fv-page-mobile-76c9971831044453c3fa9468d3708ef0.jpg";